// extracted by mini-css-extract-plugin
export default {"subTitleContainer":"InfoTitle_subTitleContainer__yQFdY","title":"InfoTitle_title__zYS+6"};